import slice from 'lodash/slice';
import isArray from 'lodash/isArray';

export default function SliceData(data, pageNo = 1, pageSize = 10) {
  if (!isArray(data) || (isArray(data) && !data.length)) {
    return [];
  }

  const start = (pageNo - 1) * pageSize;
  const end = start + pageSize;

  return slice(data, start, end);
};
